module.exports = __webpack_public_path__ + "static/media/personal_text_carousel.bd95fd1d.xlsx";